/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActionFrom;

(function (ActionFrom) {
  ActionFrom["CMS"] = "cms";
  ActionFrom["SYSTEM"] = "system";
  ActionFrom["AGENT"] = "agent";
  ActionFrom["WORKER"] = "worker";
})(ActionFrom || (ActionFrom = {}));